module.exports = __webpack_public_path__ + "img/638106b.jpg";